import { getTokenMutation } from './graphql/getTokenMutation'
import { graphqlFetch } from '@pylot-data/graphqlFetch'
import type { CustomerToken } from '@pylot-data/fwrdschema'
import { useCart, mergeCarts } from '@corratech/pylot-cart-manager'
import { useAccount } from './use-account'
import { useRouter } from 'next/router'
import { useState } from 'react'
import { useAuthUI } from './AuthContext'

export type GenerateTokenResponse = {
    data: CustomerToken
}

export type LoginArguments = {
    email: string
    password: string
    cartId?: string
}

export const useLogin = () => {
    const { mutate: fetchAccountInfo } = useAccount()
    const { mutate: updateCart } = useCart()
    const { locale } = useRouter()
    const { loginCallbacks, clearAuthCallback } = useAuthUI()
    const [isLoading, setIsLoading] = useState(false)

    return {
        login: async (params: LoginArguments) => {
            setIsLoading(true)
            const res = await graphqlFetch<
                LoginArguments,
                { generateCustomerToken: CustomerToken }
            >({
                query: getTokenMutation,
                variables: params,
                locale
            })
            if (res.errors) {
                setIsLoading(false)
                throw res.errors
            }
            localStorage.setItem(
                'pylot_token',
                res.data!.generateCustomerToken.token!
            )
            const result = await Promise.all([
                fetchAccountInfo(),
                mergeCarts({
                    guestCartId: localStorage.getItem('cart_id')!,
                    locale
                }).then((res) => updateCart(res, false))
            ])
            setIsLoading(false)
            //handle login callbacks
            if (loginCallbacks.length) {
                loginCallbacks.forEach((callback) => {
                    if (typeof callback === 'function') {
                        callback()
                    }
                })
                clearAuthCallback('LOGIN_VIEW')
            }
            return result
        },
        isLoading
    }
}
